import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#434343",
    "col2n": "#FF008C"
}
function HaiHig049({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M36.35 19.5q0-.05.05-.1h-.05q-.5-.45-.95-.85-1.7-1.65-3.45-3.25-1.6-1.5-3.2-3.1-2.45-2.45-4.75-5-1.35-1.55-2.6-3.1-.9-1.05-1.75-2.15-.3-.45-.6-.85l-.9-1.1q.05.55-6.5 8-3.75 4.2-4.1 6Q3.1 20.6 1.4 42.95-.35 65.3.05 65.3l.05-.25q.45-1.35 1.15-4.3.9-3.45 3.65-12.3-.15 5.2.35 9.1.5 3.9 2.55 7.1-.45-2.7-.3-6.1.15-3.45.85-5 .65 5.25 4.5 10.7-2.3-11.35 1.3-19.35-.7 4.65 3.95 12.2-.95-12.05 3.15-25.15l.05-.1q0 .25-.35 3.2-.3 2.9-.35 6.15-.05 3.2.75 6.9 2.4-6.4 2.6-6.9.5-1.15 1-2.25.1-.15.15-.25.05-.15.1-.25l.3-.7.65-1.25q.75-1.55 1.5-3l1.1-2 .7-1.2q.95-1.7 2-3.3.15-.25.3-.45 1.4-2.2 4.6-7.05z"
                    id="HaiHig049__Symbol_168_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M11.2 0q-.95 1.3-1.85 3.2Q8.5 5.1 7.2 8.85q-.45 1.4-.7 3.55-.3 2.15-.7 4.3-.35 2.15-.3 6.9.1 4.7-1.4 10.6-1.45 5.9-1.75 11-.25 5.05 1 11.05 1.3 5.95 1.3 9.7 0 1.45-.25 3.65-.25 1.15-.55 2.25-2.35 8.2-3.2 13.5Q-.1 90.7 0 96.25q.15 5.55 3.5 14.4v-.5q-1.35-11.8 4.75-27.2-4.85 29.2-.9 51.8.5 3.5 1.35 5.15 1.2-27.65 9.75-50.7-1.65 11.55.1 24.3.2 1.2.4 2.45.4-5.95 1.05-11.55.3-1.2.65-2.35.9-4.35 2.2-8.9 2-6.35 2.75-9.05 1.25-4.5 1.25-7.15 0-1.6-.05-2.15 0-.1-.05-.1 0-.05-.05-.1-2.4-3.35-4.45-6.75v-.05q-.55-.9-1-1.75-.05-.05-.05-.1-11.85-20.9-11.85-46.7v-2.1Q9.85 8.35 11.3 0h-.1z"
                    id="HaiHig049__Symbol_169_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#HaiHig049__Symbol_168_0_Layer0_0_FILL"
                transform="translate(96.15 209.2)"
                id="HaiHig049__col1n"
            />
            <use
                xlinkHref="#HaiHig049__Symbol_169_0_Layer0_0_FILL"
                transform="translate(87.5 134.4)"
                id="HaiHig049__col2n"
            />
        </g></g>
    )
}
export default HaiHig049
